import React, { useEffect, useRef } from "react";
import "./DosaChutneyAbout.scss"
import border from "../../assets/images/border.png"
import { sortByOrderAscending } from "../../helper/helper";
import { useSelector } from "react-redux";

const DosaChutneyAbout = () => {
    const containerRef = useRef(null);
    const contentRef = useRef(null);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    useEffect(() => {
        // const container = containerRef.current;
        // const content = contentRef.current;

        // if (!container || !content) return;

        // let scrollLeft = 0;
        // let animationFrame;

        // const clone = content.cloneNode(true);
        // container.appendChild(clone);

        // const animate = () => {
        //     scrollLeft += 0.5;
        //     if (scrollLeft >= content.scrollWidth) {
        //         scrollLeft = 0;// Reset seamlessly
        //     }
        //     container.scrollLeft = scrollLeft;
        //     animationFrame = requestAnimationFrame(animate);
        // };

        // animationFrame = requestAnimationFrame(animate);

        // return () => cancelAnimationFrame(animationFrame);
    }, []);
    const pages = useSelector((state) => state.companyData.pages)
    const page = pages.find((page) => page.PageId === "about")
    const Components = page?.Components || []
    const getImagesCarousel = (data) => {
        return (
            <div className="DosaChutneyAbout-ImageCarousel" ref={containerRef}>
                <div className="DosaChutneyAbout-Cont" ref={contentRef}>
                    {data?.map((data, index) => (
                        <img key={index} src={data?.src} alt={`img-${index}`} className="DosaChutneyAbout-Cont-image" />

                    ))}
                </div>
            </div>
        )
    }
    const getHeroComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyAbout-Hero-header":
                return <div className="DosaChutneyAbout-Hero-header">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyAbout-Hero-subheader":
                return <div className="DosaChutneyAbout-Hero-subheader">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }

    }
    const getHeroContent = (components, heroBackground) => {
        return (
            <div className="DosaChutneyAbout-Hero"
                style={{
                    backgroundImage: `linear-gradient(135deg, rgba(32, 70, 7, 0.59), rgba(19, 44, 2, 0.7)), url(${heroBackground})`
                }}>
                {sortByOrderAscending(components).map((component, key) => {
                    return (
                        getHeroComponent(component)
                    )
                })}
            </div>
        )
    }
    const getContentLeftComponentsImgsComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyAbout-Container-left-imgs-left":
                return <div className="DosaChutneyAbout-Container-left-imgs-left">
                    {component?.Data.map((comp, key) => {
                        return (
                            <img alt="" src={comp?.src} key={key} />
                        )
                    })}   </div>
            case "DosaChutneyAbout-Container-left-imgs-right":
                return <img alt="" src={component?.Props?.src} className="DosaChutneyAbout-Container-left-imgs-right" />

            default:
                return <div />
        }

    }
    const getContentLeftComponentsImgs = (components) => {
        return (

            <div className="DosaChutneyAbout-Container-left-imgs">

                {sortByOrderAscending(components).map((component, key) => {
                    return getContentLeftComponentsImgsComponents(component)
                })}
            </div>
        )
    }
    const getContentLeftComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyAbout-Container-left-tripAdvisor":
                return <img alt="" src={component?.Props?.src} className="DosaChutneyAbout-Container-tripAdvisor" />
            case "DosaChutneyAbout-Container-left-imgs":
                return getContentLeftComponentsImgs(component?.Components)
            default:
                return <div />
        }

    }
    const getContentLeft = (components) => {
        return (
            <div className="DosaChutneyAbout-Container-left">
                {sortByOrderAscending(components).map((component, key) => {
                    return getContentLeftComponents(component)
                })}
            </div>
        )
    }
    const getContainerContentComponent = (component) => {
        switch (component.ID) {
            case "DosaChutneyAbout-Container-right-header-subtext":
                return <div className="DosaChutneyAbout-Container-right-header-subtext">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyAbout-Container-right-header-text":
                return <div className="DosaChutneyAbout-Container-right-header-text">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyAbout-Container-right-header-border":
                return <img alt="" src={border}
                    className="DosaChutneyAbout-Container-right-header-border" />
            default:
                return <div />
        }

    }
    const getContentRightComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyAbout-Container-right-header":
                return <div className="DosaChutneyAbout-Container-right-header">
                    {sortByOrderAscending(component?.Components).map((component, key) => {
                        return getContainerContentComponent(component)
                    })}
                </div>
            case "DosaChutneyAbout-Container-right-boldConent":
                return <div className="DosaChutneyAbout-Container-right-boldConent">
                    {component?.Props?.text}
                </div>
            case "DosaChutneyAbout-Container-right-content":
                return <div className="DosaChutneyAbout-Container-right-content">
                    {component?.Props?.text}
                </div>
            default:
                return <div />
        }
    }
    const getContentRight = (components) => {
        return (
            <div className="DosaChutneyAbout-Container-right">
                {sortByOrderAscending(components).map((component, key) => {
                    return getContentRightComponents(component)
                })}
            </div>
        )
    }
    const getContentComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyAbout-Container-left":
                return getContentLeft(component.Components)
            case "DosaChutneyAbout-Container-right":
                return getContentRight(component.Components)
            default:
                return <div />
        }

    }
    const getContent = (components) => {
        return (
            <div className="DosaChutneyAbout-Container">
                {sortByOrderAscending(components).map((component, key) => {
                    return getContentComponents(component)
                })}
            </div>
        )
    }
    const getComponents = (component) => {
        switch (component.ID) {
            case "DosaChutneyAbout-Hero":
                return getHeroContent(component.Components, component?.Props?.bgSrc)
            case "DosaChutneyAbout-Container":
                return getContent(component.Components)
            case "DosaChutneyAbout-Images":
                return getImagesCarousel(component.Data)
            default:
                return <div />
        }

    }
    return (
        <div className="DosaChutneyAbout">
            {sortByOrderAscending(Components).map((component, key) => {
                return (<div key={key}>
                    {getComponents(component)}
                </div>)
            })}
        </div>
    )
}
export default DosaChutneyAbout